module.exports = __webpack_public_path__ + "img/1535742273.689fdf8e.jpg";